import { PlacementStatus } from '../../../enums/placement-status.enum';

export class ChangePlacementStatus {
    public static readonly type = '[JobsPlacements] Change placement status';

    constructor(public id: number, public status: PlacementStatus) { }
}
